import { useState, useEffect } from 'react';
import { Provider } from 'react-redux';

import store from 'shared/store';
//import { UploadWorkerProvider } from 'app/workers/UploadWorker';

const JsxContainer = props => {
  const {
    children
  } = props;

  // render providers before rendering children
  const [ready, setReady] = useState(false);
  useEffect(() => {
    setReady(true);
  }, []);

  return (
    <Provider store={store}>
      //<UploadWorkerProvider>
	{ready && children}
      //</UploadWorkerProvider>
    </Provider>
  )
}

export default JsxContainer;
